import { useCallback, useEffect } from 'react';
import { useAnalytics, EventType } from '../../hooks/analytics';

export const useInitUseDeskAnalytics = () => {
    const { pushEvent } = useAnalytics();

    const onClickItem = useCallback((event: Event) => {
        const liElement = event.currentTarget as HTMLLIElement;
        if (!liElement) {
            return;
        }

        pushEvent({
            event: EventType.mainEvent,
            eventAction: 'Обращение в поддержку',
            eventLabel: liElement.innerText,
        });
    }, []);

    const onClickOpen = useCallback((event: Event) => {
        const buttonElement = event.currentTarget as HTMLButtonElement;
        const isClosing = /close/.test(buttonElement?.id || '');
        pushEvent({
            event: EventType.mainEvent,
            eventAction: 'Обращение в поддержку|Основная кнопка',
            eventLabel: isClosing ? 'Закрытие' : 'Открытие',
        });

        if (!isClosing) {
            setTimeout(() => {
                const useDeskElement = document.getElementById('usedesk-messenger');
                if (!useDeskElement) {
                    return;
                }

                const items = Array.from(useDeskElement.querySelectorAll('li')).slice(0, -1);
                items.forEach((item) => item.addEventListener('click', onClickItem));
            }, 0);
        }
    }, []);

    useEffect(() => {
        const useDeskElement = document.getElementById('usedesk-messenger');
        if (!useDeskElement) {
            return;
        }

        const openButton = useDeskElement.querySelector('button#uw-main-button');
        if (!openButton) {
            return;
        }

        openButton.addEventListener('click', onClickOpen);

        return () => openButton.removeEventListener('click', onClickOpen);
    }, []);
};
